module.exports = __webpack_public_path__ + "static/img/4.9b22f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/4.jpg
// module id = hVws
// module chunks = 29